module.exports = __webpack_public_path__ + "files/9f471d34fc03746df8576680d4548ddf.png";